import React from 'react';

const LoginBackground = () => {
  return (
    <div className="fixed inset-0 z-0">
      {/* Simple gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-background"></div>

      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-primary/10 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-20 w-32 h-32 bg-accent/10 rounded-full blur-2xl"></div>
      <div className="absolute top-1/3 right-10 w-16 h-16 bg-secondary/10 rounded-full blur-lg"></div>
    </div>
  );
};

export default LoginBackground;
